<template>
  <v-main class="layout-login secondary">
    <v-container fluid fill-height class="justify-center">
      <v-row justify="center">
        <v-col style="max-width: 400px;">
          <v-card>
            <v-card-text class="text-center">
              <img
                src="@/assets/logo_capital_partners.svg"
                alt="Loyall Capital Partners"
                width="200"
                style="max-width: 50%;"
              />
            </v-card-text>

            <v-divider class="mx-4" />

            <v-slide-x-transition mode="out-in">
              <slot />
            </v-slide-x-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'LayoutLogin',
};
</script>
